import Vue from 'vue'
import {
    AssayEvaluationAssayResultRequests,
    AssayResultsRequestDelete,
    AssaysEvaluationAssayGridResponse,
    AssaysEvaluationResult
} from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.models'
import { Nullable } from '@/shared/types/app.types'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class AssaysEvaluationServices extends Vue {
    async createAnAssayResult(caseId: number, laboratoryId: number, portionId: number, sampleId: number, subportionId: number, requests: AssayEvaluationAssayResultRequests): Promise<AssaysEvaluationResult> {
        const response = await this.axios.put(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/assayResult`, requests)
        return response.data
    }
    async getAssaysEvaluation(laboratoryId: number, caseId: number, sampleId: number): Promise<AssaysEvaluationAssayGridResponse> {
        const response = await this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/subportions/assaysEvaluation`)
        return response.data
    }
    async patchAnAssayResult(assayResultId: Nullable<number>, caseId: number, laboratoryId: number, portionId: number, sampleId: number, subportionId: number, updateRequests: AssayEvaluationAssayResultRequests): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/assayResult/${assayResultId}`, updateRequests)
        return response.data
    }
    async deleteAlarmNotificationBatch(laboratoryId: number, caseId: number, sampleId: number, assayResultIds: AssayResultsRequestDelete): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/`, { data: assayResultIds })
        return response.data
    }
}

export const assaysEvaluationServices = new AssaysEvaluationServices()
